/**
 * 调音
 * */
import React, { PureComponent } from 'react';
import { Button, Modal, Slider, Switch, message, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { debounce, isString, isObject } from 'lodash-es';
import { withRouter } from '../WithRouterHOC';
import OperateContent from './components/OperateContent';
import Util from '../../script/util';
import WEBROOM from '../../store/WebRoom';
import './MusicAdjustModal.scss';

class MusicAdjustModal extends PureComponent {
  state = {
    visible: false,
    isOriginalVocal: false, // 是否开启原唱
    accVolume: 60, // 伴奏音量
    vocalVolume: 100, // 人声音量
    isOpenReverb: false, // 是否开启混响
    reverbType: 0, // 混响
    isOpen3D: false, // 是否开启3D环绕
    voiceTone: 0, // 歌曲变调
  };

  componentDidMount() {
    WEBROOM.onConfigFn('END_MUSIC_CLOSE_ADJUST', this.endMusicCloseAdjust);
  }

  componentWillUnmount() {
    WEBROOM.onDeleteEvent('END_MUSIC_CLOSE_ADJUST');
  }

  // 当前歌曲播放结束，关闭调音弹窗
  endMusicCloseAdjust = () => {
    if (this.state.visible) {
      message.info('当前歌曲演唱结束');
    }
    this.hideModal();
  };

  showModal = () => {
    let {
      isOriginalVocal = true,
      accVolume = 60,
      voiceTone = 0,
      isOpen3D = false,
    } = getLocalStorageAdjustConfig();
    const vocalVolume = getLocalStorageAdjustConfig('vocalVolume');

    this.setState({
      visible: true,
      isOriginalVocal,
      accVolume,
      vocalVolume,
      voiceTone,
      isOpen3D,
    });
  };

  // 隐藏弹窗
  hideModal = () => {
    this.setState({ visible: false, isOpenReverb: false, reverbType: 0 });
  };

  // 切换原唱
  onChangeSwitchOrigin = (checked) => {
    WEBROOM.webrtc.CopyrightedMusic.checkMusicOrigin(
      !!checked,
      null,
      (status) => {
        if (status == null) {
          setLocalStorageAdjustConfig('isOriginalVocal', !!checked);
          this.setState({ isOriginalVocal: !!checked });
        }
      }
    );
  };

  // 切换混响开关
  onChangeSwitchReverb = (checked) => {
    if (checked) {
      const { reverbType } = this.state;
      let curReverbType = reverbType;
      if (reverbType === 0) {
        // 如果未设置过，则默认选中第一个
        const first = WEBROOM.webrtc.CopyrightedMusic.musicPresetEnum[0];
        curReverbType = first ? first.code : 0;
      }
      this.setState({ reverbType: curReverbType });
      WEBROOM.webrtc.CopyrightedMusic.changeMusicPreset(curReverbType);
    } else {
      this.clickChangeReverbType(0);
    }
    WEBROOM.webrtc.CopyrightedMusic.changeHeadphoneMonitor(checked);
    this.setState({ isOpenReverb: checked });
  };

  // 切换混响
  clickChangeReverbType = (code) => {
    this.setState({ reverbType: Number(code) });
    WEBROOM.webrtc.CopyrightedMusic.changeMusicPreset(code);
  };

  // 重唱
  onClickAgain = () => {
    const { playingSong, startDownloadMusic } = this.props;
    if (!WEBROOM.webrtc.CopyrightedMusic.nowMusicResourceInfo) {
      startDownloadMusic(playingSong, 'auto');
    } else {
      WEBROOM.webrtc.CopyrightedMusic.againMusic(playingSong.songId);
    }
  };
  // 3D环绕
  clickChange3DSurround = (checked) => {
    if (WEBROOM.webrtc.CopyrightedMusic.enableLiveAudioEffect) {
      if (Util.checkClientVersion(316)) {
        setLocalStorageAdjustConfig('isOpen3D', checked);
        WEBROOM.webrtc.CopyrightedMusic.enableLiveAudioEffect(checked);
        this.setState({ isOpen3D: checked });
      } else {
        message.warning('当前版本不支持该功能，请尝试更新客户端版本');
      }
    } else {
      message.warning('当前版本不支持该功能，请尝试更新客户端版本');
    }
  };

  // 手动点击变调
  clickChangeVoiceTone = (type) => {
    const { voiceTone } = this.state;
    let first = voiceTone,
      two = voiceTone;
    if (voiceTone > 0) first = 0;
    if (voiceTone < 0) two = 0;
    if (type === 'plus') {
      if (first === 0) {
        two += 0.1;
      } else if (first < 0) {
        first += 0.1;
      }
    } else if (type === 'reduce') {
      if (two === 0) {
        first -= 0.1;
      } else if (two > 0) {
        two -= 0.1;
      }
    }
    const tone = first || two;
    this.setState({ voiceTone: tone });
    this.onChangeVolume(voiceTone, 'voiceTone');
  };

  // 修改音量 type: acc 伴奏/vocal 人声 voiceTone 歌曲变调
  onChangeVolume = debounce((volume, type) => {
    if (type === 'acc') {
      setLocalStorageAdjustConfig('accVolume', volume);
      WEBROOM.webrtc.CopyrightedMusic.changeMusicVolume(volume);
    } else if (type === 'vocal') {
      WEBROOM.webrtc.setSpeakVolume(volume, true);
    } else if (type === 'voiceTone') {
      if (WEBROOM.webrtc.CopyrightedMusic.setVoiceChangerParam) {
        if (Util.checkClientVersion(316)) {
          setLocalStorageAdjustConfig('voiceTone', volume);
          WEBROOM.webrtc.CopyrightedMusic.setVoiceChangerParam(volume);
        } else {
          message.warning('当前版本不支持该功能，请尝试更新客户端版本');
        }
      } else {
        message.warning('当前版本不支持该功能，请尝试更新客户端版本');
      }
    }
  }, 300);

  render() {
    const {
      visible,
      isOriginalVocal,
      accVolume,
      vocalVolume,
      voiceTone,
      reverbType,
      isOpenReverb,
      isOpen3D,
    } = this.state;
    return (
      <Modal
        open={visible}
        mask={false}
        title={null}
        footer={null}
        centered={true}
        keyboard={false}
        maskClosable={false}
        width={442}
        closable={false}
        wrapClassName="daidai-modal-style has-top-border music-adjust-modal"
      >
        <OperateContent onClose={this.hideModal} />
        <h2 className="title">调音</h2>
        <div className="adjust-from-wrap">
          <div className="form-row">
            <label className="row-label">原唱</label>
            <div className="row-content">
              <Switch
                checked={isOriginalVocal}
                onChange={this.onChangeSwitchOrigin}
              />
            </div>
          </div>
          <div className="form-row">
            <label className="row-label">重唱</label>
            <div className="row-content">
              <Button className="btn-again" onClick={this.onClickAgain}>
                <span className="icon-again" /> 重唱
              </Button>
            </div>
          </div>
          <div className="form-row">
            <div className="form-row">
              <label className="row-label">
                伴奏增强
                <span className="tip-text">
                  3D环绕{' '}
                  <Tooltip title="开启伴奏增强后，空间感增强，乐器声音增强突出。">
                    <QuestionCircleOutlined />
                  </Tooltip>
                </span>
              </label>
              <div className="row-content">
                <Switch
                  checked={isOpen3D}
                  onChange={this.clickChange3DSurround}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <label className="row-label">伴奏音量</label>
            <div className="row-content">
              <Slider
                defaultValue={accVolume}
                onChange={(value) => this.onChangeVolume(value, 'acc')}
              />
            </div>
          </div>
          <div className="form-row">
            <label className="row-label">人声音量</label>
            <div className="row-content">
              <Slider
                value={vocalVolume}
                onChange={(value) => {
                  this.setState({ vocalVolume: value });
                  this.onChangeVolume(value, 'vocal');
                }}
              />
            </div>
          </div>
          <div className="form-row">
            <label className="row-label">歌曲变调</label>
            <div className="row-content voice-tone">
              <i
                className="icon-voice-tone reduce"
                onClick={() => this.clickChangeVoiceTone('reduce')}
              />
              <Slider
                range
                min={-12}
                max={12}
                step={0.1}
                value={[
                  voiceTone < 0 ? voiceTone : 0,
                  voiceTone > 0 ? voiceTone : 0,
                ]}
                onChange={(value) => {
                  const [min, max] = value;
                  const tone = min === 0 ? max : min;
                  this.setState({ voiceTone: tone });
                  this.onChangeVolume(tone, 'voiceTone');
                }}
              />
              <i
                className="icon-voice-tone plus"
                onClick={() => this.clickChangeVoiceTone('plus')}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-row">
              <label className="row-label">
                混响
                <span className="tip-text">使用声卡时建议关闭混响</span>
              </label>
              <div className="row-content">
                <Switch
                  checked={isOpenReverb}
                  onChange={this.onChangeSwitchReverb}
                />
              </div>
            </div>
            <div className="row-content whole-line">
              {!!WEBROOM?.webrtc?.CopyrightedMusic?.musicPresetEnum?.length &&
                WEBROOM.webrtc.CopyrightedMusic.musicPresetEnum.map((n, i) => (
                  <div
                    key={n.codeNum}
                    className={Util.classNames(
                      'reverb-type',
                      `reverb-type-${i + 1}`,
                      { active: reverbType === n.code }
                    )}
                    onClick={() => this.clickChangeReverbType(n.code)}
                  >
                    {n.title}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

// 本地缓存记住配置
export const getLocalStorageAdjustConfig = (item) => {
  let vocalConfig = {
    isOriginalVocal: true, // 是否开启原唱
    accVolume: 60, // 伴奏音量
  };
  if (item === 'vocalVolume') {
    let speakVolume = Util.readCookie('speakVolume');
    if (speakVolume && !isNaN(speakVolume)) {
      speakVolume = parseInt(speakVolume);
    } else {
      speakVolume = 100;
    }
    return Number(speakVolume);
  }
  const ddVocalConfig = window.localStorage.getItem('dd_vocal_config') || {};
  if (isString(ddVocalConfig)) {
    vocalConfig = { ...vocalConfig, ...JSON.parse(ddVocalConfig) };
  }

  if (item == null) return vocalConfig;
  if (vocalConfig[item] != null) return vocalConfig[item];
  return null;
};

export const setLocalStorageAdjustConfig = (item, newData) => {
  let vocalConfig = window.localStorage.getItem('dd_vocal_config') || {};
  if (isString(vocalConfig)) {
    vocalConfig = JSON.parse(vocalConfig);
  }
  if (isObject(vocalConfig)) {
    vocalConfig[item] = newData;
  }
  window.localStorage.setItem('dd_vocal_config', JSON.stringify(vocalConfig));
};

export default withRouter(MusicAdjustModal, { withRef: true });
